import type { CarouselDefaultSettings } from './defaultSettings';

interface mapCarouselDefaultSettings extends CarouselDefaultSettings {
  carouselArrowBackgroundColor: string;
  carouselArrowColor: string;
  carouselArrowBackgroundColorOnHover: string;
  carouselArrowColorOnHover: string;
  carouselArrowSize: number;
  carouselPaginationColor: string;
}

export const mapCarouselLayoutSettings = (
  settings: mapCarouselDefaultSettings
) => {
  const {
    carouselColumnsMode,
    carouselColumnsDesktopLarge,
    carouselColumnsDesktopMedium,
    carouselColumnsDesktopSmall,
    carouselColumnsTablet,
    carouselColumnsMobile,
    carouselRows,
    carouselRowsOnMobile,
    carouselItemSpacing,
    limitTotalNumberOfItems,
    totalNumberOfItems,

    carouselScrollMode,
    carouselAutoplay,
    carouselAutoplayPauseOnHover,
    carouselAutoplayInterval,
    carouselAnimationType,
    carouselAnimationSpeed,
    carouselPagination,
    carouselArrowsEnable,
    carouselArrowsShowOnHover,
    carouselArrowsOnMobileEnable,
    carouselSwipeDesktopEnable,
    carouselSwipeMobileEnable,
    carouselRtl,

    carouselArrowBackgroundColor,
    carouselArrowColor,
    carouselArrowBackgroundColorOnHover,
    carouselArrowColorOnHover,
    carouselArrowSize,
    carouselPaginationColor
  } = settings;

  return {
    columnsMode: carouselColumnsMode,
    columnsDesktopLarge: carouselColumnsDesktopLarge,
    columnsDesktopMedium: carouselColumnsDesktopMedium,
    columnsDesktopSmall: carouselColumnsDesktopSmall,
    columnsTablet: carouselColumnsTablet,
    columnsMobile: carouselColumnsMobile,
    rows: carouselRows,
    rowsOnMobile: carouselRowsOnMobile,
    itemSpacing: carouselItemSpacing,
    limitTotalNumberOfItems,
    totalNumberOfItems,

    scrollMode: carouselScrollMode,
    autoplay: carouselAutoplay,
    pauseOnHover: carouselAutoplayPauseOnHover,
    autoplayInterval: carouselAutoplayInterval,
    animationType: carouselAnimationType,
    animationSpeed: carouselAnimationSpeed,
    pagination: carouselPagination,
    arrowsEnable: carouselArrowsEnable,
    arrowsShowOnHover: carouselArrowsShowOnHover,
    arrowsOnMobileEnable: carouselArrowsOnMobileEnable,
    swipeDesktopEnable: carouselSwipeDesktopEnable,
    swipeMobileEnable: carouselSwipeMobileEnable,
    rtl: carouselRtl,

    arrowBackgroundColor: carouselArrowBackgroundColor,
    arrowColor: carouselArrowColor,
    arrowBackgroundColorOnHover: carouselArrowBackgroundColorOnHover,
    arrowColorOnHover: carouselArrowColorOnHover,
    arrowSize: carouselArrowSize,
    paginationColor: carouselPaginationColor
  };
};
